module.exports = __webpack_public_path__ + "b6d9fccdcffc6c0663733fcc68ad3408.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/barcode-scan.png
// module id = 185
// module chunks = 0